<script setup>
import TheHero from './TheHero.vue'
import CartSearchPageResult from './CartSearchPageResult.vue'
import { useForm } from 'vee-validate'
import { useCartStore } from '../stores/cartStore'
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import CartBusinessDetails from './CartBusinessDetails.vue'
import TheAlert from './TheAlert.vue'
import CartBOILandingPageFAQ from './CartBOILandingPageFAQ.vue'

const props = defineProps({
  cartData: Object,
  cartSlug: String,
  company_uuid: {
    type: String,
    default: null,
    required: false
  }
})

const cartStore = useCartStore()

const { values, defineField, meta, handleSubmit } = useForm()
const [searchQuery, searchAttrs] = defineField('searchQuery')
const route = useRoute()

const userId = ref(null)
const companiesList = ref([])
const submitted = ref(false)

const onSubmit = handleSubmit(async (values) => {
  cartStore.setIsLoading(true)
  const response = await cartStore.searchForCompany(
    values.searchQuery,
    userId.value,
    props.cartSlug
  )
  companiesList.value = response.companies
  submitted.value = true
  cartStore.setIsLoading(false)
})

const heroContent = {
  title: props.cartData.title,
  subtitle: props.cartData.subtitle
}

onMounted(async () => {
  userId.value = route.query.user_id

  if (userId.value) {
    try {
      cartStore.setIsLoading(true)
      heroContent.subtitle = 'Select one your businesses below to get started.'
      const response = await cartStore.searchForCompany('', userId.value)
      companiesList.value = response.companies
      cartStore.setIsLoading(false)
    } catch (error) {
      console.error('Failed to fetch companies:', error)
    }
  }
})
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-10">
      <TheAlert
        v-if="cartStore.cartData.cartConfig.urgencyBanner"
        :content="cartStore.cartData.cartConfig.urgencyBanner"
      />
    </div>
    <div
      v-if="cartData.initialFormData"
      id="welcome-mat"
      class="col-md-10 col-lg-10"
    >
      <TheHero :content="cartData" />
      <div class="row justify-content-center">
        <div :class="{ 'col-md-10 col-lg-8': !cartData.includeNav }">
          <CartBusinessDetails :cartData="cartData.initialFormData" />
        </div>
      </div>
    </div>
    <div v-if="!userId & !cartData.initialFormData" class="col-md-10 col-lg-10">
      <TheHero :content="heroContent" />
      <h3 class="text-center mb-3">
        Search for your business below to get started.
      </h3>
      <div class="row justify-content-center">
        <div class="col-10">
          <form @submit="onSubmit">
            <!-- Input Card -->
            <div class="input-card">
              <div class="input-card-form">
                <div class="input-group input-group-merge">
                  <label
                    for="searchAnswersForm"
                    class="form-label visually-hidden"
                    >Search for answers</label
                  >
                  <span class="input-group-prepend input-group-text">
                    <i class="fa-light fa-magnifying-glass"></i>
                  </span>
                  <input
                    v-model="searchQuery"
                    v-bind="searchAttrs"
                    type="text"
                    class="form-control"
                    id="searchForm"
                    placeholder="Acme Corporation, LLC"
                    aria-label="Search for answers"
                  />
                </div>
              </div>
              <button class="btn btn-primary btn-icon">
                <i class="fa-light fa-arrow-right"></i>
              </button>
            </div>

            <!-- End Input Card -->
          </form>
          <p v-if="values.searchQuery && submitted" class="text-muted">
            <small
              >Showing Results for
              <span class="text-primary text-highlight-primary">{{
                values.searchQuery
              }}</span></small
            >
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-10 col-lg-10">
      <TheHero v-if="userId" :content="heroContent" />
      <div class="row justify-content-center">
        <div class="col-10">
          <div v-for="company in companiesList" v-bind:key="company.id">
            <CartSearchPageResult :company="company" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="cartData.slug === 'boi-report'"
    class="row justify-content-center mt-5"
  >
    <div class="col-md-10 col-lg-10">
      <div class="row justify-content-center">
        <div class="col-xs-12 col-sm-10">
          <CartBOILandingPageFAQ />
        </div>
      </div>
    </div>
  </div>
</template>
